import { getIn } from 'formik'

export const errorHandler = (name, touched, errors) =>
  getIn(touched, name) && getIn(errors, name) != null
